module.exports = __webpack_public_path__ + "img/gridicon.137810a6.svg";